import React from 'react'
import { connect } from 'react-redux'
import BusinessForm from './BusinessForm'

import {
  clear_business,
} from '../actions'

const mapStateToProps = state => {
  return {

  }
}
const mapDispatchToProps = dispatch => {
  return {
    clearBusiness: () => dispatch( clear_business() ),
  }
}

class ConnectedBusinessEdit extends React.Component {
  componentWillMount() {
    this.props.clearBusiness()
  }

  render(){
    const {business_id} = this.props.match.params

    return <BusinessForm actionName="update" business_id={business_id}/>
  }
}

const BusinessEdit = connect(mapStateToProps, mapDispatchToProps)(ConnectedBusinessEdit)
export default BusinessEdit



// WEBPACK FOOTER //
// ./src/js/components/BusinessEdit.js